import * as React from 'react'
import type { SVGProps } from 'react'
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.034 4.091 8.837 8.487l-4.915.707c-.882.126-1.235 1.198-.596 1.813l3.557 3.42-.841 4.83c-.152.873.78 1.527 1.56 1.118L12 18.095l4.397 2.28c.78.406 1.713-.245 1.562-1.118l-.842-4.83 3.557-3.42c.639-.614.286-1.687-.596-1.813l-4.915-.707-2.197-4.396c-.394-.783-1.535-.793-1.932 0"
    />
  </svg>
)
export default SvgStar
